class NavToggle {
  constructor() {
    this.nav = document.getElementById("js-nav");
    this.humberger = document.getElementById("js-nav-humberger");
    this.humberger.addEventListener('click', () => {
      this.humberger.classList.toggle('open');
      this.nav.classList.toggle('nav-open');
    });
  }
}
new NavToggle();

class HeartFadeIn {
  constructor() {
    this.targets = document.querySelectorAll('.heart');
    this.targetsArray = Array.prototype.slice.call(this.targets);
    this.options = {
      root: null,
      rootMargin: "0px 0px -10%",
      threshold: 0
    }
    this.io = new IntersectionObserver(this.cb, this.options);
    this.targetsArray.forEach(el => {
      this.io.observe(el);
    });
  }
  cb(entries, observer) {
    entries.forEach((entry, i) => {
      const target = entry.target;
      if(entry.isIntersecting && !target.classList.contains('show')) {
        const delay =  i * 300;
        setTimeout(function(){
          target.classList.add('show');
        },delay);
        observer.unobserve(entry.target);
      }
    });
  }
}
new HeartFadeIn();